import { getElements, ifSelectorExist } from "./utils";

export const showMore = () => {
  const showMoreButtons = getElements(".reviews-item_show_more");
  if (ifSelectorExist(showMoreButtons)) {
    showMoreButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const reviewBlock = this.closest(".reviews-item");
        const shortReview = reviewBlock.querySelector(".short-review");
        const fullReview = reviewBlock.querySelector(".full-review");

        if (shortReview.style.display === "none") {
          shortReview.style.display = "inline";
          fullReview.style.display = "none";
          this.textContent = "see more";
        } else {
          shortReview.style.display = "none";
          fullReview.style.display = "inline";
          this.textContent = "see less";
        }
      });
    });
  }
};

export const loadMoreReview = () => {
  let textContainers = document.querySelectorAll(".review-loadmore");
  let maxLength = 335;

  textContainers.forEach((container) => {
    let text = container.textContent.trim();

    if (text.length > maxLength) {
      let endIndex = text.lastIndexOf(" ", maxLength);
      let truncatedText = text.substring(0, endIndex);
      let remainingText = text.substring(endIndex);

      let toggleButton = document.createElement("button");
      toggleButton.textContent = "... see more";

      toggleButton.onclick = function () {
        if (toggleButton.textContent === "... see more") {
          container.textContent = truncatedText + remainingText;
          toggleButton.textContent = " see less";
        } else {
          container.textContent = truncatedText;
          toggleButton.textContent = "... see more";
        }
        container.appendChild(toggleButton);
      };

      container.textContent = truncatedText;
      container.appendChild(toggleButton);
    }
  });
};
